import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNoindex } from "../seo/useSeoHead";

export default function NotFoundPage() {
  const { t } = useTranslation("common");
  // Ein statischer Host liefert unbekannte Pfade als HTTP 200 aus —
  // ohne `noindex` würden daraus „Soft 404" im Suchindex.
  useNoindex();
  return (
    <div className="flex min-h-[60vh] flex-col items-start justify-center gap-3" data-testid="not-found-page">
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-400">404</span>
      <h1 className="text-4xl font-semibold tracking-tight">{t("notFound.title")}</h1>
      <p className="max-w-md text-sm text-zinc-400">{t("notFound.body")}</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="rounded-md border border-zinc-700 px-3 py-2 text-sm text-zinc-200 hover:bg-zinc-900"
      >
        {t("notFound.back")}
      </Link>
    </div>
  );
}
